import { useCallback, useEffect, useState } from "react";

export const useCountDown = ({ ...props }: UseCountDownProps): [number, (from?: number) => void, () => void] => {
    const [counter, setCounter] = useState<number>(props.from);

    useEffect(() => {
        if (counter === -1) {
            return;
        }

        if (counter > 0) {
            const timer = setInterval(() => setCounter(counter - 1), 1000);
            return () => clearInterval(timer);
        } else {
            props.onDone();
        }
    }, [counter]);

    const resetCounter = useCallback((from: number = props.from): void => {
        setCounter(from);
    }, []);

    const cancelCounter = useCallback((): void => {
        setCounter(-1);
    }, []);

    return [counter, resetCounter, cancelCounter];
};

/** Sleep for N seconds.
 * @param timer as seconds
 */
export const sleepFor = async (timer: number): Promise<void> => {
    return await new Promise((resolve) => {
        setTimeout(resolve, timer * 1000);
    });
};

interface UseCountDownProps {
    from: number;
    onDone: () => void;
}
